var C;!function(C){C.UPLOADING="UPLOADING",C.SUCCESS="SUCCESS",C.FAILED="FAILED",C.CANCELLED="CANCELLED"}(C||(C={}));export{C as FileActiveUploadStatusEnum};